// extracted by mini-css-extract-plugin
export var text = "_38-0";